module.exports = __webpack_public_path__ + "National2Web-Bold.woff?5163ddb630b14b64c7ce891f1f96254f";